
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { ContractGroup } from "@/lib/types";

interface GroupDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  group: ContractGroup | null;
  onDelete: (groupId: string) => Promise<void>;
  isPending?: boolean;
  isLoading?: boolean;
  onConfirm?: () => void;
}

export function GroupDeleteDialog({
  open,
  onOpenChange,
  group,
  onDelete,
  isPending,
  isLoading,
  onConfirm,
}: GroupDeleteDialogProps) {
  const isDisabled = isPending || isLoading;
  
  const handleDelete = async () => {
    if (onConfirm) {
      onConfirm();
      return;
    }
    
    if (group) {
      await onDelete(group.id);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete the group{" "}
            <strong>{group?.name}</strong> and all associated data.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDisabled}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={isDisabled}
          >
            {isPending || isLoading ? "Deleting..." : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
